module.exports = __webpack_public_path__ + "img/circle_icon_3.0040585.svg";